export default "dist/fonts/30BCD6_B_0.ttf";